































































import Vue, { PropType } from "vue";
import { get_color_by_name } from "@/utils/colors";
import {
  Candidates,
  FrequentJobSwitch
} from "@/interfaces/data_objects/candidates";

export default Vue.extend({
  name: "UserFrequentJob",
  data() {
    return {
      frequent_job_search: {} as FrequentJobSwitch
    };
  },
  props: {
    profile: {
      type: Object as PropType<Candidates.CandidateDetails>,
      required: true
    },
    recruiter_view: {
      type: Boolean,
      default: true
    }
  },
  created() {
    if (this.profile.profile && this.profile.profile?.frequent_switch) {
      this.frequent_job_search = this.profile.profile.frequent_switch;
    }
  },
  methods: {
    transform_source(icon: HTMLElement): HTMLElement {
      for (let node of icon.children)
        node.setAttribute("fill", get_color_by_name("primary"));
      return icon;
    }
  }
});
